import { useDispatch, useSelector } from "react-redux";
import { Button, Input } from "../../../components/ui";
import { TRootState } from "../../../store";
import SelectDate from "../../../components/ui/select-date";
import { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import useAxiosClient from "../../../hooks/useAxiosClient";
import { setArrivalPmtHistory } from "../../../reducers/arrivalDetails_slice";
import { setRefreshMovePmt } from "../../../reducers/trade_details_Slice";
import { useUIPermissions } from "../../../layout/config/permissionUtils";

const ConfirmReceiptArrival = () => {
  const {
    role,
    arrivalpmtHistory,
    tradeDetailsById,
    adminId,
    tradeId,
    traderId,
    refresh,
    arrivalPmtToggle,
  } = useSelector((state: TRootState) => ({
    role: state.auth.userInfo?.roleType,
    arrivalpmtHistory: state.arrivalDetails.arrivalpmtHistory,
    tradeDetailsById: state.tradeDetailsById.tradeDetailsbyId,
    adminId: state.auth.adminId,
    tradeId: state.tradeDetails.tradeId,
    traderId: state.tradeDetails.traderId,
    refresh: state.trades.refresh,
    arrivalPmtToggle: state.arrivalDetails.arrivalPmtToggle,
  }));
  const { hasAdminManagerEditAccess } = useUIPermissions();
  const dispatch = useDispatch();

  const { handlePutCall } = useAxiosClient();

  const [pmtReceiptDate, setPmtReceiptDate] = useState(
    tradeDetailsById?.freightDtls?.pmtDate
      ? moment(tradeDetailsById?.freightDtls?.pmtDate).format("DD-MMM-YYYY")
      : moment().format("DD-MMM-YYYY"),
  );
  const [utr, setUtr] = useState(
    tradeDetailsById?.freightDtls?.utr
      ? tradeDetailsById?.freightDtls?.utr
      : "",
  );
  const [paymentDesc, sertpaymentDesc] = useState(
    tradeDetailsById?.freightDtls?.descr
      ? tradeDetailsById?.freightDtls?.descr
      : "",
  );

  const savePaymentReceipt = () => {
    if (utr === "") {
      toast.error("Please enter UTR number");
      return;
    }

    handlePutCall({
      URL: "admin/trade-platform/freight",
      apiParams: {
        adminId: adminId,
        comments: tradeDetailsById?.freightDtls?.comments,
        date: moment(tradeDetailsById?.freightDtls?.date).format("YYYY-MM-DD"),
        descr: paymentDesc,
        freightPaid: tradeDetailsById?.freightDtls?.freightPaid,
        images: [],
        paidTo: tradeDetailsById?.freightDtls?.paidTo,
        pmtDate: moment(pmtReceiptDate).format("YYYY-MM-DD"),
        pmtMode: tradeDetailsById?.freightDtls?.pmtMode,
        pmtStatus: "ACCEPTED",
        tradeId: tradeId,
        utr: utr,
      },
    }).then(({ data }) => {
      toast.success("Updated successfully");
      dispatch(setArrivalPmtHistory(false));
      dispatch(setRefreshMovePmt(true));
    });
  };
  const handlePaymentReceiptDate = (_date: string) => {
    let date = moment(_date).format("YYYY-MM-DD");
    setPmtReceiptDate(date);
  };

  return (
    <>
      <div className="border-gray br-10 m-4 mb-4">
        <div
          className={`py-3 px-4 fs-14 font-semibold rounded-t-lg`}
          style={{
            background: "#EBFFF0",
          }}
        >
          Confirm Receipt
        </div>
        <div className="px-4 py-2 bg-white w-full">
          {" "}
          <div className="flex py-3 gap-4">
            <div className="w-[50%]">
              <span className="font-semibold fs-14">
                Payment Receipt Date<span className="color-red">*</span>
              </span>
              <SelectDate
                onChange={handlePaymentReceiptDate}
                selectedDate={pmtReceiptDate}
              />
            </div>

            <div className="w-[50%]">
              <Input
                type="text"
                required={true}
                label={"UTR Number"}
                value={utr}
                onChange={(e) => setUtr(e.target.value)}
                inputStyle={{ marginTop: "10px" }}
              />
            </div>
          </div>
          <div className="flex py-3 flex-col">
            <span className="fs-14">Description </span>
            <Input
              value={paymentDesc}
              onChange={(e) => sertpaymentDesc(e.target.value)}
              className="w-[100%]"
            />
          </div>
          {hasAdminManagerEditAccess && !arrivalPmtToggle && (
            <div className="flex justify-end pb-2">
              {" "}
              <Button
                variant="contained"
                className=""
                onClick={() => {
                  savePaymentReceipt();
                }}
              >
                Save
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default ConfirmReceiptArrival;
